/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

(function menuAccordionFunction() {
    function initAccordion(el) {
        const accordion = el;
        const items = accordion.querySelectorAll(".js-accordion-item");
        const triggers = accordion.querySelectorAll(".js-accordion-trigger");
        const hiddenContent = accordion.querySelectorAll(".js-accordion-hidden");
        const filtersAccordion = accordion.classList.contains("filters__accordion");
        let current = null;
        let clearDisplayTimeout = null;

        function openEvent(index, event, preset = false) {
            if (event) event.preventDefault();

            if (clearDisplayTimeout) clearTimeout(clearDisplayTimeout);

            if (current !== null && !preset) {
                const previousIndex = current;
                items[current].classList.remove("open");
                hiddenContent[current].style.removeProperty("max-height");

                if (filtersAccordion) {
                    document.body.setAttribute("data-filter-open", "");
                }

                clearDisplayTimeout = setTimeout(() => {
                    hiddenContent[previousIndex].style.removeProperty("display");
                }, 800);

                if (index === current) {
                    current = null;
                    return;
                }
            }

            hiddenContent[index].style.display = "block";
            items[index].classList.add("open");

            const firstChild = hiddenContent[index].querySelector("*");
            if (firstChild) {
                hiddenContent[index].style.maxHeight = firstChild.offsetHeight + "px";
            }

            current = index;

            if (filtersAccordion) {
                document.body.setAttribute("data-filter-open", current);
            }
        }

        function _init() {
            for (let i = 0; i < items.length; i++) {
                if (triggers[i]) {
                    triggers[i].addEventListener("click", (event) => openEvent(i, event));
                }
            }

            setTimeout(() => {
                accordion.classList.add("init");
            }, 250);
        }

        _init();
    }

    function initializeAccordions() {
        const accordions = document.querySelectorAll('.js-block[data-block="accordion"]');
        accordions.forEach(initAccordion);
    }

    document.addEventListener("DOMContentLoaded", initializeAccordions);

    window.rfd = window.rfd || {};
    window.rfd.menuAccordionFunction = menuAccordionFunction;
})();


// For Gallery:

document.addEventListener("DOMContentLoaded", function() {
    const thumbnailLinks = document.querySelectorAll('.pdp-gallery__gallery-thumb a');
    
    // Set the first image opacity to 0.2
    if (thumbnailLinks.length > 0) {
      const firstImage = thumbnailLinks[0].querySelector('img');
      firstImage.style.opacity = '0.2';
    }
  
    thumbnailLinks.forEach(function(link) {
      link.addEventListener("click", function(event) {
        event.preventDefault();
        // Reset opacity for all images
        thumbnailLinks.forEach(function(otherLink) {
          const otherImage = otherLink.querySelector('img');
          otherImage.style.opacity = '1';
        });
        // Set the opacity of the clicked image to 0.2
        const image = link.querySelector('img');
        image.style.opacity = '0.2';
      });
    });
  });


// Original gallery functionality
document.addEventListener('DOMContentLoaded', function() {
  var galleryList = document.querySelector('.pdp-gallery__gallery-list');
  var galleryItems = document.querySelectorAll('.pdp-gallery__gallery-item');
  var thumbs = document.querySelectorAll('.pdp-gallery__gallery-thumb a');
  var dots = document.querySelectorAll('.pdp-gallery__gallery-dots li');

  // Set active image function
  function setActiveImage(index) {
    galleryItems.forEach(function(item, idx) {
      item.style.opacity = idx === index ? '1' : '0';
    });
    
    // Update desktop wrap data-current
    const desktopWrap = document.querySelector('.pdp-gallery__desktop-wrap');
    if (desktopWrap) {
      desktopWrap.setAttribute('data-current', index.toString());
    }
    
    // Update dots
    if (dots.length) {
      dots.forEach(dot => dot.classList.remove('active'));
      if (dots[index]) dots[index].classList.add('active');
    }
  }

  // Handle thumbnail click
  thumbs.forEach(function(thumb, index) {
    thumb.addEventListener('click', function(event) {
      event.preventDefault();
      setActiveImage(index);
    });
  });

  // Handle featured image click to open zoomed image
  galleryItems.forEach(function(item) {
    item.addEventListener('click', function() {
      var imageUrl = item.querySelector('figure').getAttribute('data-image');
      window.open(imageUrl, '_blank');
    });
  });

  // Set initial state
  setActiveImage(0);
});

// Variant change handler
document.addEventListener('variant:changed', function(event) {
    const variant = event.detail.variant;
    if (!variant || !variant.featured_image) return;
  
    const galleryItems = document.querySelectorAll('.pdp-gallery__gallery-item');
    const thumbnailLinks = document.querySelectorAll('.pdp-gallery__gallery-thumb a');
    let variantImageIndex = -1;
  
    galleryItems.forEach((item, index) => {
      const imgElement = item.querySelector('img');
      if (imgElement && imgElement.getAttribute('data-id') === variant.featured_image.id.toString()) {
        variantImageIndex = index;
      }
    });
  
    if (variantImageIndex !== -1) {
      // Update main gallery image
      galleryItems.forEach((item) => {
        item.style.opacity = '0';
      });
      galleryItems[variantImageIndex].style.opacity = '1';
  
      // Update desktop wrap
      const desktopWrap = document.querySelector('.pdp-gallery__desktop-wrap');
      if (desktopWrap) {
        desktopWrap.setAttribute('data-current', variantImageIndex.toString());
      }
  
      // Update dots
      const dots = document.querySelectorAll('.pdp-gallery__gallery-dots li');
      if (dots.length) {
        dots.forEach(dot => dot.classList.remove('active'));
        if (dots[variantImageIndex]) dots[variantImageIndex].classList.add('active');
      }
  
      // Update thumbnail opacities
      thumbnailLinks.forEach((link, index) => {
        const thumbImage = link.querySelector('img');
        thumbImage.style.opacity = index === variantImageIndex ? '0.2' : '1';
      });
    }
  });

  document.addEventListener('variant:changed', function(event) {
    const variant = event.detail.variant;
    if (!variant || !variant.featured_image) return;
  
    const carousel = document.querySelector('.carousel');
    if (!carousel) return;
  
    const flkty = Flickity.data(carousel);
    if (!flkty) return;
  
    // Find the slide with the variant image
    const slides = carousel.querySelectorAll('img');
    let variantSlideIndex = -1;
  
    slides.forEach((slide, index) => {
      if (slide.getAttribute('data-image-id') === variant.featured_image.id.toString()) {
        variantSlideIndex = index;
      }
    });
  
    if (variantSlideIndex !== -1) {
      // Select the variant slide
      flkty.select(variantSlideIndex, false, true);
    }
  });
  